import { render } from "./EmailFailedModal.vue?vue&type=template&id=1f36874f&scoped=true"
import script from "./EmailFailedModal.vue?vue&type=script&lang=js"
export * from "./EmailFailedModal.vue?vue&type=script&lang=js"

import "./EmailFailedModal.vue?vue&type=style&index=0&id=1f36874f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f36874f"]])

export default __exports__